// ZYBERSEC Mock Data

export const heroData = {
  tagline: "Private, secure access to AI",
  description: "AI tools are unavoidable. The security model hasn't evolved. ZYBERSEC provides a hardened, isolated virtual environment that absorbs risk and keeps your systems private.",
  ctaPrimary: "Read Docs",
  ctaSecondary: "Architecture"
};

export const problemData = [
  {
    id: 1,
    title: "Data Privacy Is Based on Trust, Not Architecture",
    points: [
      "Privacy relies on policies, not technical safeguards",
      "Data leakage and session logging",
      "Model training on sensitive inputs",
      "Loss of control once data leaves your device"
    ]
  },
  {
    id: 2,
    title: "Local Device Exposure",
    points: [
      "AI accessed via browsers creates direct exposure",
      "Browser fingerprinting and cookie leakage",
      "Risks from extensions and injected scripts",
      "Your machine becomes the attack surface"
    ]
  },
  {
    id: 3,
    title: "Compromised Package Dependencies",
    points: [
      "AI generates code requiring dependencies",
      "Single compromised package executes malicious code",
      "Wallet drainage, key theft, credential exposure",
      "Even experts can't audit every package"
    ]
  },
  {
    id: 4,
    title: "Payment and Financial Exposure",
    points: [
      "Card details stored with third parties",
      "Billing data becomes a breach vector",
      "Forced use of legacy payment rails",
      "Financial privacy sacrificed for convenience"
    ]
  }
];

export const architectureData = {
  title: "ZYBERSEC Architecture",
  subtitle: "Your computer should never be the attack surface.",
  nodes: [
    { id: "user", label: "User Device", description: "Stays private. No direct AI connection." },
    { id: "zyber", label: "ZYBER Virtual Environment", description: "Hardened, isolated sandbox. All AI interactions occur here." },
    { id: "ai", label: "AI Providers", description: "Chat, Coding Agents, Autonomous Tools" }
  ],
  features: [
    "No direct connection between AI and your local system",
    "Environment does not connect to open internet",
    "All sessions isolated, controlled, and sandboxed",
    "Users interact through ZYBER; AI never touches your device"
  ]
};

export const paymentsData = {
  title: "Crypto-Native Payments",
  subtitle: "No cards. No stored billing data. No breach vectors.",
  flow: [
    { step: 1, label: "Crypto", description: "User pays with cryptocurrency" },
    { step: 2, label: "ZYBER Partner", description: "Converts crypto to fiat" },
    { step: 3, label: "Fiat", description: "Pays AI providers directly" }
  ],
  benefits: [
    "Never enter card details",
    "No stored billing exposure",
    "Transparent crypto-based pricing"
  ]
};

export const buildData = {
  title: "ZYBER BUILD",
  subtitle: "Secure AI-assisted development. Zero local exposure.",
  features: [
    "Build websites, dApps, bots, full-stack products",
    "No local package installation",
    "No dependency risk on your machine",
    "No exposure to compromised libraries",
    "Real-time cost simulation before execution"
  ],
  codeExample: `// Cost Simulation\n> Project: E-commerce Platform\n> Estimated AI Tokens: 45,000\n> Execution Cost: 12.5 ZSEC\n> Build Time: ~4 minutes\n\n[SIMULATE] [BUILD] [EXPORT]`,
  terminalOutput: [
    "$ zyber build --project ecommerce",
    "Initializing secure environment...",
    "Loading AI coding systems...",
    "Dependencies resolved in sandbox",
    "No local packages installed",
    "Build complete. Exporting..."
  ]
};

export const footerData = {
  links: [
    { label: "Problem", href: "#problem" },
    { label: "Solution", href: "#solution" },
    { label: "Build", href: "#build" },
    { label: "Docs", href: "https://docs.zybersec.pro" }
  ],
  social: [
    { label: "X", href: "https://x.com/zybersecai" }
  ],
  copyright: "© 2026 ZYBERSEC. All rights reserved."
};
